export default __webpack_public_path__ + "static/media/flag-turks-and-caicos.b0efeef9.svg";